import { render, staticRenderFns } from "./PartnerQualifications.vue?vue&type=template&id=3dae625e"
import script from "./PartnerQualifications.vue?vue&type=script&lang=js"
export * from "./PartnerQualifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports